import React from 'react'
import { Link } from 'react-router-dom'
export const VideoPublicidad = () => {
    return (
        process.env.REACT_APP_URL_TEST === "true" &&
        <section>
            SECCION VIDEO YOUTUBE MARCOS HABLANDO A CAMARA.
        </section>
    )
}